import _styled from "@emotion/styled-base";
import React from 'react';
import PropTypes from 'prop-types';
import Icon, { getIconColor } from '../Icon/Icon';
import Text from '../Text/Text';
import { elo as theme } from '../../themes';
import iconList from '../Icon/iconList';
import { jsx as ___EmotionJSX } from "@emotion/core";
var iconColor = function iconColor(_ref) {
  var item = _ref.item;
  var color = theme.colors.shade70;
  if (item.dimmed) {
    color = theme.colors.shade60;
  }
  if (item.brand) {
    color = theme.colors.brand30;
  }
  return color;
};
var StyledListItem = _styled("li", {
  target: "e1ktz4bl0"
})("display:flex;", function (_ref2) {
  var item = _ref2.item;
  return getIconColor(iconColor({
    item: item
  }));
}, " p{margin-left:", theme.spacings.xxxSmall, ";}:not(:last-of-type){margin-bottom:", function (props) {
  return props.item.small ? theme.spacings.xxxSmall : theme.spacings.xxSmall;
}, ";}" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
var List = function List(_ref3) {
  var items = _ref3.items;
  return ___EmotionJSX("ul", null, items.map(function (item, index) {
    return ___EmotionJSX(StyledListItem, {
      item: item,
      key: "item-" + index
    }, ___EmotionJSX(Icon, {
      type: item.icon || 'bullet'
    }), ___EmotionJSX(Text, {
      size: item.small ? 't3' : 't2',
      brand: item.brand,
      dimmed: item.dimmed && !item.brand
    }, item.label));
  }));
};
List.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    icon: PropTypes.oneOf([].concat(Object.keys(iconList), [''])),
    brand: PropTypes.bool,
    dimmed: PropTypes.bool,
    small: PropTypes.bool
  }))
};
export default List;